module.exports = __webpack_public_path__ + "static/media/packages.394509e6.png";